
import React, { useState, useEffect, useCallback } from 'react';
import { cn } from '@/lib/utils';

interface TypingEffectProps {
  text: string;
  className?: string;
  speed?: number;
  cursorStyle?: string;
  showCursor?: boolean;
}

export const TypingEffect = ({ 
  text, 
  className, 
  speed = 50, 
  cursorStyle = "|",
  showCursor = true
}: TypingEffectProps) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  // Optimize the typing effect using useCallback
  const typeNextChar = useCallback(() => {
    if (currentIndex < text.length) {
      setDisplayText(prev => prev + text[currentIndex]);
      setCurrentIndex(prev => prev + 1);
    }
  }, [currentIndex, text]);

  useEffect(() => {
    // Reset state when text prop changes
    if (!text) return;
    
    setDisplayText('');
    setCurrentIndex(0);
  }, [text]);

  useEffect(() => {
    if (currentIndex < text.length) {
      // Calculate a slightly variable speed for more natural typing
      const variableSpeed = speed * (0.8 + Math.random() * 0.4);
      
      const timeout = setTimeout(typeNextChar, variableSpeed);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, text, speed, typeNextChar]);

  return (
    <span className={cn(className)} style={{ willChange: 'contents' }}>
      {displayText}
      {showCursor && currentIndex < text.length && (
        <span className="animate-pulse inline-block">{cursorStyle}</span>
      )}
    </span>
  );
};
